import React from 'react';
import styles from './commentary_list.module.scss';
import { WebCommentary } from '../commentary.types';
import { OpenCommentaryCard } from '../card/OpenCommentaryCard';

type Props = {
  commentary: WebCommentary;
  onCommentaryClicked: Function;
  source: string;
};

export const CommentaryListOpenCommentary: React.FC<Props> = (props: Props) => (
  <OpenCommentaryCard
    {...props}
    className={`${styles.commentaryItem} ${styles.pointer}`}
  />
);
